import React from 'react'
import Card from 'react-bootstrap/Card';
import './Carousel_cult.css'
import img from './photos/sld5.jpg'
import img1 from './photos/sld6.jpg'
import img2 from './photos/sld7.jpg'
import img3 from './photos/sld8.jpg'

function Carousel_cult1() {
  return (
    <div className='carousel_div'>
       <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img}/>
        <h1>SCULPTURE</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img1}/>
        <h1>HIMACHAL REPRESENT</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img2}/>
        <h1>PUBLIC WORK</h1>
      </Card.Body>
    </Card>
    <Card style={{ width: '20rem', height: '30rem', backgroundColor: 'white', boxShadow: 'inset 2px 2px 2px 2px gray'}}>
      <Card.Body className='card_body'>
        <img src={img3}/>
        <h1>SANAT GALERY</h1>
      </Card.Body>
    </Card>
    </div>
  )
}

export default Carousel_cult1
